import React  from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';

import MainNavigation from './shared/components/Navigation/MainNavigation';
import Footer from './shared/components/Navigation/Footer';
//import LoadingSpinner from './shared/components/UIElements/LoadingSpinner';
import Datasets from './datasets/pages/Datasets';
import Classes from './classes/pages/Classes';
import ViewDataset from './datasets/pages/ViewDataset';
import ViewClass from './classes/pages/ViewClass';
import Recommender from './recommender/pages/Recommender';
import About from './shared/components/Navigation/About';

import ReactGA from 'react-ga';

import './App.css';

//const Classes = React.lazy(()=>import('./classes/pages/Classes'));
//const ViewDataset = React.lazy(()=>import('./datasets/pages/ViewDataset'));
//const ViewClass = React.lazy(()=>import('./classes/pages/ViewClass'));
//const Recommender = React.lazy(()=>import('./recommender/pages/Recommender'));

function initializeReactGA() {
  ReactGA.initialize('UA-188357974-1');
}
initializeReactGA();

function App() {

  return (
      <Router>
        <MainNavigation />
        <main>
        <Switch>
        <Route path="/" exact>
        <Redirect to="/datasets"/>
        </Route>
        <Route path="/datasets" exact>
          <Datasets />
        </Route>
        <Route path="/datasets/:datasetId">
          <ViewDataset />
        </Route>
        <Route path="/classes" exact>
          <Classes />
        </Route>
        <Route path="/classes/:classId">
          <ViewClass />
        </Route>
        <Route path="/recommender" exact>
          <Recommender />
        </Route>
        <Route path="/about" exact>
          <About />
        </Route>
        <Redirect to="/" />
      </Switch>
        </main>
        <Footer/>
        
      </Router>
      
  
    
  );
}

export default App;
